import {httpsFunctions} from "../../../../api/Api";
import {onrejected} from "../utils/onrejected";

export const memberHasEmail = (member) => {
    return httpsFunctions.post('/memberHasEmail', {id: member})
        .then(response => {
            return {
                hasEmail: response.data.data?.hasEmail || false,
                secureEmail: response.data.data?.secureEmail,
                error: response.data?.error
            }
        })
        .catch(onrejected)
};
